export const escapeCSVField = (field) => {
  if (field == null) return "";
  const str = String(field).replace(/"/g, '""'); 
  return `"${str}"`;
};